import Chart from 'chart.js/auto';

document.addEventListener('turbo:load', () => {
  // 体重・体脂肪率グラフ
  const chartCanvas = document.getElementById('progressChart');
  if (chartCanvas && window.bodyMeasurementData) {
    // 既存のチャートがある場合は破棄
    const existingChart = Chart.getChart(chartCanvas);
    if (existingChart) {
      existingChart.destroy();
    }

    const ctx = chartCanvas.getContext('2d');
    const data = window.bodyMeasurementData;

    // グラフの作成
    const chart = new Chart(ctx, {
    type: 'line',
    data: {
      labels: data.dates,
      datasets: [
        {
          label: '体重 (kg)',
          data: data.weights,
          borderColor: '#2196f3',
          backgroundColor: 'rgba(33, 150, 243, 0.1)',
          tension: 0.4,
          yAxisID: 'y-weight',
        },
        {
          label: '体脂肪率 (%)',
          data: data.bodyFats,
          borderColor: '#e91e63',
          backgroundColor: 'rgba(233, 30, 99, 0.1)',
          tension: 0.4,
          yAxisID: 'y-fat',
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            font: {
              size: 11
            },
            padding: 10,
            usePointStyle: true,
            pointStyle: 'circle'
          }
        },
        tooltip: {
          mode: 'index',
          intersect: false,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          titleFont: {
            size: 12
          },
          bodyFont: {
            size: 11
          },
          padding: 8,
          cornerRadius: 4
        }
      },
      scales: {
        x: {
          grid: {
            display: false
          },
          ticks: {
            font: {
              size: 10
            }
          }
        },
        'y-weight': {
          type: 'linear',
          display: true,
          position: 'left',
          grid: {
            color: 'rgba(0, 0, 0, 0.05)'
          },
          ticks: {
            font: {
              size: 10
            },
            callback: function(value) {
              return value + 'kg';
            }
          }
        },
        'y-fat': {
          type: 'linear',
          display: true,
          position: 'right',
          grid: {
            drawOnChartArea: false
          },
          ticks: {
            font: {
              size: 10
            },
            callback: function(value) {
              return value + '%';
            }
          }
        }
      }
    }
    });

    // 期間セレクターの処理
    const periodButtons = document.querySelectorAll('.period-btn');
    periodButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        // アクティブクラスの切り替え
        periodButtons.forEach(btn => btn.classList.remove('active'));
        e.target.classList.add('active');

        // TODO: 選択された期間に応じてデータをフィルタリングする処理
        const period = e.target.dataset.period;
        console.log('Selected period:', period);
      });
    });
  }

  // 筋肉量グラフ
  const muscleChartCanvas = document.getElementById('muscleChart');
  if (muscleChartCanvas && window.muscleMassData) {
    // 既存のチャートがある場合は破棄
    const existingMuscleChart = Chart.getChart(muscleChartCanvas);
    if (existingMuscleChart) {
      existingMuscleChart.destroy();
    }

    const muscleCtx = muscleChartCanvas.getContext('2d');
    const muscleData = window.muscleMassData;

    // 筋肉量グラフの作成
    const muscleChart = new Chart(muscleCtx, {
      type: 'line',
      data: {
        labels: muscleData.dates,
        datasets: [
          {
            label: '筋肉量 (kg)',
            data: muscleData.muscleMass,
            borderColor: '#4caf50',
            backgroundColor: 'rgba(76, 175, 80, 0.1)',
            tension: 0.4,
            fill: true,
            pointRadius: 4,
            pointHoverRadius: 6
          },
          {
            label: '骨格筋量 (kg)',
            data: muscleData.skeletalMuscleMass,
            borderColor: '#ff9800',
            backgroundColor: 'rgba(255, 152, 0, 0.1)',
            tension: 0.4,
            fill: true,
            pointRadius: 4,
            pointHoverRadius: 6
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                size: 11
              },
              padding: 10,
              usePointStyle: true,
              pointStyle: 'circle'
            }
          },
          tooltip: {
            mode: 'index',
            intersect: false,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            titleFont: {
              size: 12
            },
            bodyFont: {
              size: 11
            },
            padding: 8,
            cornerRadius: 4,
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += context.parsed.y.toFixed(1) + 'kg';
                }
                return label;
              }
            }
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              font: {
                size: 10
              }
            }
          },
          y: {
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            },
            ticks: {
              font: {
                size: 10
              },
              callback: function(value) {
                return value + 'kg';
              }
            }
          }
        }
      }
    });

    // 筋肉量グラフの期間セレクター処理
    const musclePeriodButtons = document.querySelectorAll('.muscle-period-btn');
    musclePeriodButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        // アクティブクラスの切り替え
        musclePeriodButtons.forEach(btn => btn.classList.remove('active'));
        e.target.classList.add('active');

        // TODO: 選択された期間に応じてデータをフィルタリングする処理
        const period = e.target.dataset.period;
        console.log('Selected muscle period:', period);
      });
    });
  }
});